<template>
  <div class="Contact container ">

    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <div class="tile is-child box">
          <h1 class="title is-2">{{ $t('contact.title') }}</h1>
          <h3 class="subtitle is-4">{{ $t('contact.description') }}</h3>
        </div>
      </div>
    </div>

    <div class="tile is-ancestor">
      <div class="tile is-parent">
        <div class="tile is-child box">
          <div class="contact-container">
            Location: <span class="contact-text place">Monterrey | Nuevo Leon, Mex.</span>
            Phone: <span class="contact-text phone">
              <a href="tel:52-812-111-9244" title="Give me a call">+52 (812) 111 9244</a>
            </span>
            Email: <span class="contact-text gmail">
              <a href="mailto:ghernandez.9002@gmail.com" title="Send me an email">ghernandez.9002@gmail.com</a>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div>
      <hr>
      <ul class="social-media-list">
        <li :click="goToUrl(1)">
          <a href="https://github.com/GilbertoHdz" target="_blank" class="contact-icon">
            <font-awesome-icon :icon="[ 'fab', 'github' ]" aria-hidden="true" />
          </a>
        </li>
        <li  :click="goToUrl(2)">
          <a href="https://www.linkedin.com/in/gilbertohdz9002/" target="_blank" class="contact-icon">
            <font-awesome-icon :icon="[ 'fab', 'linkedin' ]" aria-hidden="true" />
          </a>
        </li>
        <li>
          <a href="https://medium.com/@gilbertohdz" target="_blank" class="contact-icon">
            <font-awesome-icon :icon="[ 'fab', 'medium' ]" aria-hidden="true" />
          </a>
        </li>
        <li>
          <a href="https://twitter.com/_GilbertoHdz_" target="_blank" class="contact-icon">
            <font-awesome-icon :icon="[ 'fab', 'twitter' ]" aria-hidden="true" />
          </a>
        </li>
        <li>
          <a href="https://app.pluralsight.com/profile/gilberto-hernand-20" target="_blank" class="contact-icon">
            <img class="icon-png" :src="'../img/pluralsight.png'">
          </a>
        </li>
        <li>
          <a :href="'../files/Gilberto Hernandez Gutierrez.docx'" target="_blank" class="contact-icon">
            <font-awesome-icon :icon="[ 'fas', 'file-word' ]" aria-hidden="true" />
          </a>
        </li>
      </ul>
      <hr>
    </div>
  </div>
</template>

<script>
export default {
  name: "Contact",

  methods: {
    goToUrl(value) {
      console.log("TEST", value);
    }
  }
}
</script>

<style lang="scss">
.Contact {
  // font-family: 'Sans Forgetica';
  color: $green;
  margin-top: 4em !important;

  .box {
    color: $green;
    background-color: $background;
    box-shadow: none;
  }

  .contact-container {
    display: inline-grid;
  }

  .icon-png {
    filter: invert(1);
  }

  /* Begin Right Contact Page */
  .direct-contact-container {
    max-width: 400px;
    float: right;
    margin-top: 5px;
  }

  /* Location, Phone, Email Section */
  .contact-list {
    list-style-type: none;
    margin-left: -30px;
    padding-right: 20px;
  }

  .list-item {
    line-height: 4;
    color: #aaa;
  }

  .contact-text {
    letter-spacing: 1.9px;
    color: #bbb;
  }

  .contact-text a {
    color: #bbb;
    text-decoration: none;
    transition-duration: 0.2s;
  }

  /* Social Media Icons */
  .social-media-list {
    position: relative;
    font-size: 2.3rem;
    text-align: center;
    width: 100%;
    display: inline-flex;
  }

  .social-media-list li a {
    color: #fff;
  }

  .social-media-list li {
    position: relative;
    top: 0;
    display: inline-block;
    height: 70px;
    width: 70px;
    margin: 10px auto;
    line-height: 70px;
    border-radius: 50%;
    color: #fff;
    background-color: rgb(27,27,27);
    cursor: pointer;
    transition: all .2s ease-in-out;
  }

  .social-media-list li:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 70px;
    height: 70px;
    line-height: 70px;
    border-radius: 50%;
    opacity: 0;
    box-shadow: 0 0 0 1px #fff;
    transition: all .2s ease-in-out;
    z-index: -1;
  }

  .social-media-list li:hover {
    background-color: #fff;

    .icon-png {
      filter: invert(0);
    }
  }

  .social-media-list li:hover:after {
    opacity: 1;
    transform: scale(1.12);
    transition-timing-function: cubic-bezier(0.37,0.74,0.15,1.65);
  }

  .social-media-list li:hover a {
    color: #111;
  }

  hr {
    border-color: rgba(255,255,255,.8); ;
  }

  /* Begin Media Queries*/
  @media screen and (max-width: 760px) {
    .direct-contact-container, .form-horizontal {
      float: none;
      margin: 10px auto;
    }
    .direct-contact-container {
      margin-top: 60px;
      max-width: 300px;
    }
    .social-media-list li {
      height: 60px;
      width: 60px;
      line-height: 60px;
    }
    .social-media-list li:after {
      width: 60px;
      height: 60px;
      line-height: 60px;
    }
  }

  @media screen and (max-width: 569px) {
    .social-media-list {
      left: 0;
    }
    .social-media-list li {
      height: 55px;
      width: 55px;
      line-height: 55px;
      font-size: 2rem;
    }
    .social-media-list li:after {
      width: 55px;
      height: 55px;
      line-height: 55px;
    }
  }

  @media screen and (max-width: 410px) {
    .send-button {
      width: 99%;
    }
  }
}
</style>
